module.exports = __webpack_public_path__ + "media/img/testing-solutions/solution-banner-icon-bfc6a0f5458cb74f14c9972f1099757c.svg";